// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__0B26_","content":"style_content___5HdK"};